export function moreLink() {
    return '<label class="more-link">Показать еще</label>';
}

export function lessLink() {
    return '<label class="less-link">Скрыть</label>';
}